export {
  createStableWidgetMessageId,
  createWidgetMessageId,
  isWidgetMessageId,
  resolveWidgetMessageId,
  WIDGET_MESSAGE_ID_PREFIX,
} from '@teo/widget-shared';

/** Stable id for optimistic user messages (survives server id swap). */
export function createClientMessageId(): string {
  return `client-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}
